import React from 'react';
export function Wave() {
  return <div className="relative w-32 h-3 mx-auto overflow-hidden opacity-50" data-id="element-124">
      <svg className="absolute w-[200%] animate-wave" viewBox="0 0 100 10" preserveAspectRatio="none" data-id="element-125">
        <path d="M-100 5 C -70 2, -30 8, 0 5 C 30 2, 70 8, 100 5 C 130 2, 170 8, 200 5" fill="none" stroke="white" strokeWidth="0.5" data-id="element-126" />
      </svg>
    </div>;
}